import React, { useState, useEffect } from "react";

const ResolutionModal = ({ isOpen, onClose, onDownload, onSendEmail }) => {
    const [resolution, setResolution] = useState(300);
    const [email, setEmail] = useState("");
    const [sendOption, setSendOption] = useState("download");
    const [isSuccess, setIsSuccess] = useState(false);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setResolution(300);
            setEmail("");
            setSendOption("download");
            setIsSuccess(false);
            setError("");
            setIsLoading(false);
        }
    }, [isOpen]);

    useEffect(() => {
        if (email) {
            setError("");
        }
    }, [email]);

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleDownload = () => {
        const validResolution = Math.min(Math.max(resolution, 300), 2000);
        onDownload(validResolution);
        onClose();
    };

    const handleSendEmail = async () => {
        if (!validateEmail(email)) {
            setError("Por favor, insira um email válido.");
            return;
        }

        const validResolution = Math.min(Math.max(resolution, 300), 2000);
        setIsLoading(true);
        try {
            await onSendEmail(validResolution, email);
            setIsSuccess(true);
            setError("");
        } catch {
            setError("Erro ao enviar o email. Tente novamente.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                {isLoading ? (
                    <div className="loading-message">
                        <h2>Aguarde...</h2>
                        <p>Estamos enviando seu QrCode...</p>
                    </div>
                ) : !isSuccess ? (
                    <>
                        <h2>Opções de Download</h2>
                        <div className="form-group">
                            <label htmlFor="resolution">Resolução (px)</label>
                            <input
                                type="number"
                                id="resolution"
                                value={resolution}
                                onChange={(e) => setResolution(e.target.value)}
                                min="300"
                                max="2000"
                            />
                        </div>
                        <div className="form-group radio-group">
                            <label className={`radio-label ${sendOption === "download" ? "selected" : ""}`}>
                                <input
                                    type="radio"
                                    name="sendOption"
                                    value="download"
                                    checked={sendOption === "download"}
                                    onChange={() => setSendOption("download")}
                                />
                                <span className="custom-radio"></span>
                                Download
                            </label>
                            <label className={`radio-label ${sendOption === "email" ? "selected" : ""}`}>
                                <input
                                    type="radio"
                                    name="sendOption"
                                    value="email"
                                    checked={sendOption === "email"}
                                    onChange={() => setSendOption("email")}
                                />
                                <span className="custom-radio"></span>
                                Enviar por Email
                            </label>
                        </div>
                        {sendOption === "email" && (
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Digite seu email"
                                />
                                {error && <p className="error-message">{error}</p>}
                            </div>
                        )}
                        <div className="modal-buttons">
                            {sendOption === "download" ? (
                                <button className="btn" onClick={handleDownload}>Download</button>
                            ) : (
                                <button className="btn" onClick={handleSendEmail}>Enviar por Email</button>
                            )}
                            <button className="btn" onClick={onClose}>Cancelar</button>
                        </div>
                    </>
                ) : (
                    <>
                        <h2>Enviado com Sucesso!</h2>
                        <p>O email foi enviado com sucesso.</p>
                        <button className="btn" onClick={onClose}>Fechar</button>
                    </>
                )}
            </div>
        </div>
    );
};

export default ResolutionModal;